import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal } from '@shared/ui';

import { useWeatherModal } from './useWeatherModal';
import cls from './WeatherModal.module.css';
import { GoogleComponent } from '../../../../components/newUI/GoogleComponent/GoogleComponent';

interface WeatherModalProps {
    classes?: string;
}

export const WeatherModal = memo(({ classes }: WeatherModalProps) => {
    const { modalMode, onCancel, information } = useWeatherModal();

    const { t } = useTranslation();

    return (
        <CustomModal isOpen={modalMode === 'weatherModal'} onHideModal={onCancel} classes={classes}>
            <CustomModal.Header>{t('WeatherModal.return.ModalHeader')}</CustomModal.Header>
            <CustomModal.Body>
                <div className={cls.map}>
                    <GoogleComponent
                        mapCenter={{
                            lat: information.latitude,
                            lng: information.longitude,
                        }}
                        lat={information.latitude}
                        lng={information.longitude}
                    />
                </div>
            </CustomModal.Body>
        </CustomModal>
    );
});
